import { ColorType, createChart } from 'lightweight-charts';
import { useEffect, useRef } from 'react';

// Generic reusable area chart. data: [{ time: unixSeconds | 'YYYY-MM-DD', value: number }]
export default function Chart({
  data,
  height = 100,
  colors: {
    backgroundColor = 'transparent',
    lineColor = '#f16724',
    textColor = '#888',
    areaTopColor = 'rgba(241, 103, 36, 0.4)',
    areaBottomColor = 'rgba(241, 103, 36, 0.04)',
  } = {},
}) {
  const containerRef = useRef(null);
  const chartRef = useRef(null);
  const seriesRef = useRef(null);

  // chart banata hai sirf ek baar
  useEffect(() => {
    if (!containerRef.current) return;

    const chart = createChart(containerRef.current, {
      layout: { background: { type: ColorType.Solid, color: backgroundColor }, textColor, attributionLogo: false },
      width: containerRef.current.clientWidth,
      height,
      timeScale: { visible: false, borderVisible: false },
      rightPriceScale: { visible: false, borderVisible: false },
      leftPriceScale: { visible: false },
      grid: { vertLines: { visible: false }, horzLines: { visible: false } },
      crosshair: {
        vertLine: { visible: false, labelVisible: false },
        horzLine: { visible: false, labelVisible: false },
      },
      handleScroll: false,
      handleScale: false,
    });

    const series = chart.addAreaSeries({
      lineColor,
      topColor: areaTopColor,
      bottomColor: areaBottomColor,
      lineWidth: 2,
      priceLineVisible: false,
      lastValueVisible: false,
      crosshairMarkerVisible: false,
    });
    chartRef.current = chart;
    seriesRef.current = series;

    const handleResize = () => {
      if (containerRef.current) chart.applyOptions({ width: containerRef.current.clientWidth });
    };
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      chart.remove();
      chartRef.current = null;
      seriesRef.current = null;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [height, backgroundColor, lineColor, textColor, areaTopColor, areaBottomColor]);

  // sirf data update hone par chart recreate nahi hota
  useEffect(() => {
    if (!seriesRef.current || !data || data.length === 0) return;
    seriesRef.current.setData(data);
    chartRef.current?.timeScale().fitContent();
  }, [data]);

  return <div ref={containerRef} />;
}
